import React from 'react';
import classnames from 'classnames';
import Layout from 'sections/Layout';

import Hero from 'sections/TemplatePost/Hero';
import Content from 'sections/TemplatePost/Content';
import Rating from 'sections/common/Rating';
import Share from 'sections/ResourceCenterPost/Share';
import MoreStoriesSec from 'sections/common/MoreStoriesSec';
import Subscribe from 'components/Forms/SubscribeForm';

import useAllTemplatesPosts from 'hooks/graphql/useAllTemplatesPosts';
import useOptions from 'hooks/graphql/useOptions';
import { TEMPLATES_PAGE } from 'constants/urls';

import * as styles from 'styles/pages/template-post.module.scss';

const TemplatePost = ({ templatePost, ...props }) => {
  const allTemplatesPosts = useAllTemplatesPosts();
  const options = useOptions();

  const {
    content,
    databaseId,
    slug,
    title,
    excerpt,
    tags,
    id,
    template,
    categories,
    seo,
  } = templatePost;

  const postType =
    template.templateName === 'Template Inner' ? 'inner' : 'lead';

  const currentPostTag = categories.nodes[0]?.name;

  const additionalLink = {
    text: 'More Content',
    url: TEMPLATES_PAGE,
  };

  const subscribeData = {
    subscribeFormTitle: 'Get your copy of the guide here!',
    subscribeForm: {
      subscribeFormInputLabel: 'you’ll receive it as a pdf file',
      subscribeFormButtonTitle: 'Get the guide',
    },
  };

  const {
    resourceCenterPostInfoTrial: {
      resourceCenterPostInfoTrialTitle,
      resourceCenterPostInfoTrialUrl,
      resourceCenterPostInfoTrialMarketedText,
    },
  } = options.resourceCenterPostInfo.resourceCenterPostInfo;

  const contentHead = {
    title: title,
    excerpt: excerpt,
  };

  return (
    <Layout
      seo={seo}
      headerDarkColor={true}
      headerWhiteBg={true}
      requestButtonBlue={true}
      // ogImage={sourceUrl}
    >
      {(commonData) => (
        <>
          <div>
            <Hero tags={tags} data={template} postType={postType} />

            <div className={classnames(styles.wrapContent)}>
              <Content data={content} contentHead={contentHead} />

              {postType === 'lead' ? (
                <div className={classnames(styles.additionalPostLink)}>
                  <h5 className={classnames('scr-h5')}>
                    {resourceCenterPostInfoTrialTitle}
                    <a
                      href={resourceCenterPostInfoTrialUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={classnames('scr-link scr-blue')}
                    >
                      {resourceCenterPostInfoTrialMarketedText}
                    </a>
                  </h5>
                </div>
              ) : null}

              {postType === 'inner' ? (
                <div className={classnames(styles.postInfo)}>
                  <Rating databaseId={databaseId} />
                  <Share url={slug} title={title} tags={tags} uri={props.uri} />
                </div>
              ) : null}
            </div>

            <div>
              <div className={classnames(styles.formWrap, 'scr-wrap')}>
                <Subscribe
                  customData={postType === 'lead' ? subscribeData : {}}
                />
              </div>

              {postType === 'inner' ? (
                <MoreStoriesSec
                  tag={currentPostTag}
                  id={id}
                  title={'You May Be Interested'}
                  allPosts={allTemplatesPosts}
                  reading={true}
                  additionalLink={additionalLink}
                />
              ) : null}
            </div>
          </div>
        </>
      )}
    </Layout>
  );
};

export default TemplatePost;
